import request from '@/common/request';

// 获取屏蔽规则列表
export async function getShieldList(params) {
  return request({ url: '/qunion/shield/list', method: 'get', params });
}
// 获取屏蔽规则列表
export async function getShieldInfo(params) {
	return request({ url: '/qunion/shield/info', method: 'get', params });
}
// 新增屏蔽规则
export async function doAddShield(data) {
  return request({ url: '/qunion/shield/add', method: 'post', data });
}
export async function doEditShield(data) {
  return request({ url: '/qunion/shield/update', method: 'post', data });
}
export async function doDeleteShield(params) {
  return request({ url: '/qunion/shield/del', method: 'get', params });
}

/*
* 先投后审
*/
// 筛选
export async function getReviewCollectionAdslotList(params){
	return request({ url: '/qunion/review-collection/adslot-list', method: 'get', params });
}

// 合集
export async function getReviewCollectionInfo(params){
	return request({ url: '/qunion/review-collection/info', method: 'get', params });
}
export async function getReviewCollectionList(params){
	return request({ url: '/qunion/review-collection/list', method: 'get', params });
}
export async function setReviewCollectionAdd(data){
	return request({ url: '/qunion/review-collection/add', method: 'post', data });
}
export async function setReviewCollectionEdit(data){
	return request({ url: '/qunion/review-collection/edit', method: 'post', data });
}
export async function setReviewCollectionDelete(data){
	return request({ url: '/qunion/review-collection/delete', method: 'post', data });
}

// 素材
export async function getReviewReleaseList(params){
	return request({ url: '/qunion/review/review-list', method: 'get', params });
}
export async function getReviewBlockedList(params){
	return request({ url: '/qunion/review/block-list', method: 'get', params });
}
export async function setReviewCollection(data){
	return request({ url: '/qunion/review/review-update', method: 'post', data });
}



/*
* 先审后投
*/
// 筛选
export async function getPreviewCollectionAdslotList(params){
	return request({ url: '/qunion/collection/adslot-list', method: 'get', params });
}

// 合集
export async function getPreviewCollectionInfo(params){
	return request({ url: '/qunion/collection/info', method: 'get', params });
}
export async function getPreviewCollectionList(params){
	return request({ url: '/qunion/collection/list', method: 'get', params });
}
export async function setPreviewCollectionAdd(data){
	return request({ url: '/qunion/collection/add', method: 'post', data });
}
export async function setPreviewCollectionEdit(data){
	return request({ url: '/qunion/collection/edit', method: 'post', data });
}
export async function setPreviewCollectionDelete(data){
	return request({ url: '/qunion/collection/delete', method: 'post', data });
}

// 素材
export async function getPreviewIdeaPendingList(params){
	return request({ url: '/qunion/idea/pending-list', method: 'get', params });
}
export async function getPreviewIdeaReviewedList(params){
	return request({ url: '/qunion/idea/reviewed-list', method: 'get', params });
}
export async function setPreviewCollectionAudit(data){
	return request({ url: '/qunion/idea/audit', method: 'post', data });
}

// 报表
export async function getPreviewReportList(params){
	return request({ url: '/qunion/idea/report', method: 'get', params });
}